var bookingOptions = ["location", "service", "people", "dates", "details"];
var bookingOptionsPosition = 0;
var availableTimeSlots = {};
var availableDates = [];
var peoplesServices = [];

var customerMembershipExpiry;
var customerMembershipPoints;
var isCustomerLoggedIn;

var selectedLocationId = 0;
var selectedServiceId = 0;
var selectedProviderId = 0;
var selectedBookingDate = "";
var selectedBookingTime = "";

var processingBooking = false;

function seedMembershipFromWindow() {
  try {
    if (typeof window !== "undefined") {
      if (typeof window.customerMembershipExpiry === "string" && window.customerMembershipExpiry) {
        customerMembershipExpiry = new Date(window.customerMembershipExpiry);
      }
      if (typeof window.customerMembershipPoints !== "undefined") {
        customerMembershipPoints = parseInt(window.customerMembershipPoints, 10) || 0;
      }
      if (typeof window.isCustomerLoggedIn !== "undefined") {
        isCustomerLoggedIn = !!window.isCustomerLoggedIn;
      }
    }
  } catch (e) {
    console.log("HERE")
  }
}
seedMembershipFromWindow();

var cachedClubroomAPIBookingData = JSON.parse(
  localStorage.getItem("cachedClubroomAPIBookingData")
);
var cachedClubroomAPIBookingTime = localStorage.getItem(
  "cachedClubroomAPIBookingTime"
);


let locationNameElements = document.getElementsByClassName(
  "booking-location-name"
);
for (let element of locationNameElements) {
  element.innerHTML = "The Clubroom Hamilton Store";
}

let locationAddressElements = document.getElementsByClassName(
  "booking-location-address"
);

for (let element of locationAddressElements) {
  element.innerHTML = "Shop R54, The Base Shopping Centre, Te Rapa, NZ"
}

const today = new Date();
const formattedDateToday = `${today.getFullYear()}-${String(
  today.getMonth() + 1
).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

const fourteenDaysFromNow = new Date();
fourteenDaysFromNow.setDate(fourteenDaysFromNow.getDate() + 14);

const formattedDatefourteenDaysFromNow = `${fourteenDaysFromNow.getFullYear()}-${String(
  fourteenDaysFromNow.getMonth() + 1
).padStart(2, "0")}-${String(fourteenDaysFromNow.getDate()).padStart(2, "0")}`;

var options = {
  type: "default",
  settings: {
    visibility: {
      theme: "light",
      weekend: false,
      today: false,
    },
    range: {
      min: formattedDateToday,
      max: formattedDatefourteenDaysFromNow,
      disabled: [formattedDateToday + ':' + formattedDatefourteenDaysFromNow], // This disables the entire range
    },
  },
  actions: {
    clickDay(e, date) {
      updateDatesAvailableTimes(date);
    },
  },
};

var calendar = new VanillaCalendar("#calendar", options);

function getBookingInfo() {
  if (cachedClubroomAPIBookingData && cachedClubroomAPIBookingTime && Date.now() - cachedClubroomAPIBookingTime < 900000) {
    simplybookForm();
  } else {
    fetch("https://theclubroom-api.azurewebsites.net/booking/info")
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem(
          "cachedClubroomAPIBookingData",
          JSON.stringify(data)
        );
        localStorage.setItem("cachedClubroomAPIBookingTime", Date.now());
        cachedClubroomAPIBookingData = data;
        simplybookForm();
      })
      .catch((error) => {
        console.error("Error fetching locations:", error);
        throw error; // Re-throw the error
      });
  }
}

function handleServiceChange(serviceRadio) {
  selectedProviderId = 0;
  selectedBookingDate = "";
  selectedBookingTime = "";

  if (serviceRadio.checked) {
    selectedServiceId = serviceRadio.getAttribute("service_id");

    let serviceNameElements = document.getElementsByClassName("booking-service-name");
    for (let element of serviceNameElements) {
      element.innerHTML = serviceRadio.value;
    }

    let serviceDetailsElements = document.getElementsByClassName("booking-service-details");
    for (let element of serviceDetailsElements) {
      element.innerHTML = serviceRadio.getAttribute("servicedetails");
    }

    const usesPoints = serviceRadio.hasAttribute("data-uses-points");
    if (usesPoints) {
      const required = parseInt(serviceRadio.getAttribute("data-points-required") || "1", 10);
      // Append an inline indicator for this booking
      for (let element of serviceDetailsElements) {
        element.innerHTML += ` <span class="text-green-600 font-bold">- Using ${required} Token${required>1?"s":""}</span>`;
      }
    }

    disableCalendarWithMessage("Loading available dates...");
    setBookNowVisibility(false);
    getAvailableTimeSlots();
  }
}

function disableCalendarWithMessage(message) {
  // Add a loading overlay to the calendar
  const calendarElement = document.getElementById("calendar");
  if (calendarElement) {
    // Remove any existing overlay
    const existingOverlay = calendarElement.querySelector('.calendar-overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }
    
    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'calendar-overlay';
    overlay.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      font-weight: bold;
      color: #333;
    `;
    overlay.textContent = message;
    
    // Make calendar container relative for absolute positioning
    calendarElement.style.position = 'relative';
    calendarElement.appendChild(overlay);
  }
  
  // Disable all dates in calendar
  calendar.settings.range.disabled = [formattedDateToday + ':' + formattedDatefourteenDaysFromNow];
  calendar.reset();
}

// New function to enable calendar and remove overlay
function enableCalendarAndRemoveOverlay() {
  const calendarElement = document.getElementById("calendar");
  if (calendarElement) {
    const overlay = calendarElement.querySelector('.calendar-overlay');
    if (overlay) {
      overlay.remove();
    }
  }
}

// Modified getAvailableTimeSlots function
function getAvailableTimeSlots() {
  document.getElementById("timeHolderTitle").innerHTML = "Retrieving available times...";
  
  fetch("https://theclubroom-api.azurewebsites.net/simulator/available-times?serviceId="+selectedServiceId
      +"&startDate="+formattedDateToday
    ).then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      availableTimeSlots = data;
      calendar.settings.range.disabled = [];
      
      Object.entries(availableTimeSlots.availability).forEach(([date, slots]) => {
        if (slots.length === 0) {
          calendar.settings.range.disabled.push(date);
        }
      });
      
      enableCalendarAndRemoveOverlay();
      
      document.getElementById("timeHolderTitle").innerHTML = "Choose a day";
      calendar.reset();
    })
    .catch((error) => {
      document.getElementById("timeHolderTitle").innerHTML = "Error retrieving times";
      disableCalendarWithMessage("Error loading dates");
      throw error;
    });
}

function simplybookForm() {
  const bookingForms = document.querySelectorAll("[data-booking-form]");
  if (bookingForms) {
    bookingForms.forEach((bookingForm) => {
      const steps = bookingForm.querySelectorAll("[data-booking-step]");
      if (steps) {
        steps.forEach((step) => {
          const backButton = step.querySelector("[data-button-prev]");
          if (backButton) {
            if (step.previousElementSibling) {
              backButton.classList.remove("opacity-40");
              backButton.addEventListener("click", (e) => {
                if (bookingOptionsPosition > 0) {
                  bookingOptionsPosition--;
                  smoothScrollTo(bookingForm.parentNode);
                }
                steps.forEach((stepDiv) => {
                  stepDiv.classList.remove("flex");
                  stepDiv.classList.add("hidden");
                });
                if (step.previousElementSibling) {
                  step.previousElementSibling.classList.remove("hidden");
                  step.previousElementSibling.classList.add("flex");
                }
              });
            } else {
              backButton.classList.add("opacity-40");
            }
          }
          const nextButton = step.querySelector("[data-button-next]");
          if (nextButton) {
            if (step.nextElementSibling) {
              nextButton.addEventListener("click", (e) => {
                if (
                  bookingOptionsPosition == 1 &&
                  !isAnyServiceRadioSelected()
                ) {
                  alert("Please select a Service");
                  return;
                }
                if (
                  bookingOptionsPosition == 2 &&
                  !isBookingADateTimeSelected()
                ) {
                  alert("Please select a date and time");
                  return;
                }
                bookingOptionsPosition++;
                smoothScrollTo(bookingForm.parentNode);
                steps.forEach((stepDiv) => {
                  stepDiv.classList.remove("flex");
                  stepDiv.classList.add("hidden");
                });

                step.nextElementSibling.classList.remove("hidden");
                step.nextElementSibling.classList.add("flex");
              });
            }
          }
        });
      }
    });
  }
  populateServicesContainer();
}

function getServiceVariable() {
  let urlObj = new URL(window.location.href);
  let params = new URLSearchParams(urlObj.search);
  if (!params.get("service")) return "";
  return params.get("service");
}

function isAnyServiceRadioSelected() {
  const radios = document.querySelectorAll(
    'input[type="radio"][name="services-radio"]'
  );

  for (let radio of radios) {
    if (radio.checked) {
      return true; // At least one radio input is checked
    }
  }
  return false; // No radio inputs are checked
}

function uncheckAllServiceRadios() {
  const radios = document.querySelectorAll(
    'input[type="radio"][name="services-radio"]'
  );
  for (let radio of radios) {
    radio.checked = false;
  }
  let serviceNameElements = document.getElementsByClassName(
    "booking-service-name"
  );
  for (let element of serviceNameElements) {
    element.innerHTML = "";
  }
  let serviceDetailsElements = document.getElementsByClassName(
    "booking-service-details"
  );
  for (let element of serviceDetailsElements) {
    element.innerHTML = "";
  }
}

function isBookingADateTimeSelected() {
  return selectedBookingDate != "" && selectedBookingTime != "";
}

function populateServicesContainer() {
  var selectedLocation;
  cachedClubroomAPIBookingData.forEach((location, index) => {
    if (location.name == "The Clubroom Hamilton Store")
      selectedLocation = location;
  });
  
  document.getElementById("booking-services-holder").innerHTML = "";
  
  selectedLocation.services.forEach((service, index) => {
    if (!service.is_visible) return;
    if (!service.name.includes("Simulator Bay Hire")) return;
    if (
      service.id != 2 &&
      service.id != 3 &&
      service.id != 8 &&
      service.id != 9 &&
      service.id != 10
    )
      return;
    
    if (service.description == null) service.description = "";
    const serviceDetailsText = getServiceDetailsText(service);
    const displayPrice = getServiceDisplayPrice(service);

    const serviceIdStr = service.id.toString();
    const usesPoints = canUsePointsForService(serviceIdStr);
    const pointsRequired = getPointsRequiredForService(serviceIdStr);
    const remainingAfter = Math.max(0, customerMembershipPoints - pointsRequired);

    document.getElementById("booking-services-holder").innerHTML += `
      <div class="flex gap-6">
        <input onchange="handleServiceChange(this)" 
              service_id="${service.id}" 
              id="services-radio-${service.id}" 
              type="radio" 
              value="${service.name}" 
              servicedetails="${serviceDetailsText}" 
              ${usesPoints ? 'data-uses-points="true"' : ''}
              ${usesPoints ? `data-points-required="${pointsRequired}"` : ''}
              name="services-radio" 
              class="services-radio w-8 h-8 text-dark-blue bg-gray-100 border-2 border-gray-300 focus:ring-dark-blue dark:focus:ring-dark-blue focus:ring-2">
        <div class="flex flex-col">
          <label for="services-radio-${service.id}" class="pt-1 uppercase font-black leading-none text-dark-blue text-base md:text-[20px] max-w-md">${service.name}</label>
          <p class="uppercase text-[14px] font-bold leading-tight text-text mt-2">${serviceDetailsText}</p>
          ${usesPoints ? `<p class="text-green-600 font-bold text-xs mt-1">✓ Using ${pointsRequired} membership token${pointsRequired>1?"s":""}</p>` : ""}
          ${usesPoints && remainingAfter >= 0 ? `<p class="text-gray-500 text-xs">${remainingAfter} token${remainingAfter===1?"":"s"} remaining after booking</p>` : ""}
          <div class="prose text-[12px] font-medium leading-snug prose-p:my-1 mt-1 -ml-14 xl:ml-0">
            ${service.description}
          </div>
        </div>
      </div>
    `;
  });
}

function haveSharedValues(arr1, arr2) {
  const set1 = new Set(
    arr1.map((item) => (typeof item === "string" ? parseInt(item, 10) : item))
  );
  for (let value of arr2) {
    const intValue = typeof value === "string" ? parseInt(value, 10) : value;
    if (set1.has(intValue)) {
      return true;
    }
  }
  return false;
}

function updateDatesAvailableTimes(date) {
  document.getElementById("timeHolder").innerHTML = "";
  selectedBookingDate = date;
  selectedBookingTime = "";
  setBookNowVisibility(false);
  
  const slots = availableTimeSlots.availability[date];
  
  if (slots && slots.length > 0) {
    slots.forEach((time, timeIndex) => {
      if (isTimeAm(time)) {
        addMorningTime(time, convertTo12HourFormat(time), timeIndex);
      } else {
        addAfternoonTime(time, convertTo12HourFormat(time), timeIndex);
      }
    });
    document.getElementById("timeHolderTitle").innerHTML = "Choose a time";
  }else {
      document.getElementById("timeHolderTitle").innerHTML = "No available times on this day";
  }
}

function addMorningTime(timeValue, timeFormatted, timeIndex) {
  document.getElementById("timeHolder").classList.remove("hidden");
  document.getElementById("timeHolder").innerHTML += `
        <li class="relative">
          <input
            type="radio"
            id="morning-time-${timeIndex}"
            name="time"
            onchange="setSelectedTime(this)"
            displaytime="${timeFormatted}"
            value="${timeValue}"
            class="peer absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            required
          >
          <label
            for="morning-time-${timeIndex}"
            class=" px-3 py-2 text-[11px] font-bold rounded bg-white peer-hover:bg-dark-blue peer-hover:text-white peer-checked:bg-dark-blue peer-checked:text-white ease-custom transition-all"
            >${timeFormatted}</label
          >
        </li>
        `;
}

function addAfternoonTime(timeValue, timeFormatted, timeIndex) {
  document.getElementById("timeHolderContainer").classList.remove("hidden");
  document.getElementById("timeHolder").innerHTML += `
        <li class="relative">
          <input
            type="radio"
            id="afternoon-time-${timeIndex}"
            name="time"
            onchange="setSelectedTime(this)"
            displaytime="${timeFormatted}"
            value="${timeValue}"
            class="peer absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            required
          >
          <label
            for="time-${timeIndex}"
            class=" px-3 py-2 text-[11px] font-bold rounded bg-white peer-hover:bg-dark-blue peer-hover:text-white peer-checked:bg-dark-blue peer-checked:text-white ease-custom transition-all"
            >${timeFormatted}</label
          >
        </li>
        `;
}

function setSelectedTime(timeRadio) {
  if (timeRadio.checked) {
    setBookNowVisibility(true);
    selectedBookingTime = timeRadio.value;
    let timeNameElements = document.getElementsByClassName("booking-date-name");
    for (let element of timeNameElements) {
      let dateObj = new Date(selectedBookingDate);
      let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      element.innerHTML = `${days[dateObj.getDay()]}, ${dateObj.getDate()} ${
        months[dateObj.getMonth()]
      } ${timeRadio.getAttribute("displaytime")}`;
    }
  }
}

document.forms["bookingformsubmit"].onsubmit = function (event) {
  event.preventDefault();
  if (processingBooking) return;

  var lineItemId = 0;
  switch (selectedServiceId) {
    case "8": // 1 Hour (Mon–Wed)
      lineItemId = 41700604149825;
      break;
    case "9": // Late night 1 Hour
      lineItemId = 51634884870515;
      break;
    case "10": // Late night 2 Hour
      lineItemId = 51634886312307;
      break;
    case "2": // 1 Hour
      lineItemId = 41514852745281;
      break;
    default: // 2 Hour
      lineItemId = 41514852778049;
      break;
  }

  if (!selectedBookingDate || !selectedBookingTime) {
    return;
  }

  processingBooking = true;
  setSubmitState("loading");

  const bookingTime = `${selectedBookingDate} ${selectedBookingTime}`;
  const params = new URLSearchParams({
    variant: String(lineItemId),
    _booking_time: bookingTime,
    _location_id: 1,
    _service_id: String(selectedServiceId || ""),
  });

  fetch(`/apps/theclubroom/simulator/book?${params.toString()}`, {
    method: "GET",
    cache: "no-store",
  })
    .then(async (response) => {
      if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || "Booking request failed");
      }
      return response.json();
    })
    .then((data) => {
      if (data && data.requiresPayment && data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
        return;
      }

      if (data && data.success && !data.requiresPayment) {
        const detailBits = [];
        if (typeof data.pointsUsed !== "undefined")
          detailBits.push(`Tokens used: ${data.pointsUsed}`);
        if (typeof data.remainingPoints !== "undefined")
          detailBits.push(`Tokens remaining: ${data.remainingPoints}`);
        const details =
          detailBits.length > 0 ? ` (${detailBits.join(" · ")})` : "";

        setSubmitState("success", "Booking Confirmed");
        if (typeof data.remainingPoints !== "undefined") {
          customerMembershipPoints = parseInt(data.remainingPoints, 10) || 0;
        }
        return;
      }

      // Any other case treated as error
      throw new Error((data && data.message) || "Unexpected response from server.");
    })
    .catch((error) => {
      console.error("Booking error:", error);
      setSubmitState("error");
      processingBooking = false;
    });
};


function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

function isTimeAm(time) {
  const hour = parseInt(time.split(":")[0], 10);
  if (hour < 12) {
    return true;
  } else {
    return false;
  }
}

function convertTo12HourFormat(time) {
  let [hour, minute] = time.split(":").map((val) => parseInt(val, 10));

  let period = hour < 12 ? "AM" : "PM";

  // Convert to 12-hour format
  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour -= 12;
  }
  if (minute == 0) return `${hour}${period}`;
  return `${hour}:${minute}${period}`;
}

function smoothScrollTo(element) {
  const startPosition = window.pageYOffset;
  const targetPosition =
    element.getBoundingClientRect().top + window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 100; // Duration of the animation in milliseconds
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(elapsedTime / duration, 1);
    window.scrollTo(0, startPosition + progress * distance);
    if (progress < 1) {
      window.requestAnimationFrame(animation);
    }
  }

  window.requestAnimationFrame(animation);
}

function checkMembershipStatus() {
  const membershipExpiryString = window.customerMembershipExpiry;
  const membershipPoints = window.customerMembershipPoints || 0;
  const loggedIn = window.isCustomerLoggedIn || false;
  
  if (membershipExpiryString) {
    customerMembershipExpiry = new Date(membershipExpiryString);
  }
  customerMembershipPoints = parseInt(membershipPoints);
  isCustomerLoggedIn = loggedIn;
}

function canUsePointsForService(serviceId) {
  if (!isCustomerLoggedIn) return false;
  if (!customerMembershipExpiry) return false;

  const today = new Date();
  const isExpired = today > customerMembershipExpiry;
  if (isExpired) return false;

  const required = getPointsRequiredForService(serviceId);
  if (required <= 0) return false;

  return customerMembershipPoints >= required;
}

function getServiceDisplayPrice(service) {
  const serviceIdStr = service.id.toString();
  if (canUsePointsForService(serviceIdStr)) {
    const required = getPointsRequiredForService(serviceIdStr);
    return `FREE (uses ${required} membership token${required > 1 ? "s" : ""})`;
  }
  return `$${service.price}`;
}

function getServiceDetailsText(service) {
  const priceText = getServiceDisplayPrice(service);
  return `${service.duration} minutes · ${priceText}`;
}

function getPointsRequiredForService(serviceId) {
  // serviceId is string
  if (serviceId === "2") return 1; // Simulator Bay Hire (1 hr)
  if (serviceId === "3") return 2; // Simulator Bay Hire (2 hr)
  return 0;
}

function setBookNowVisibility(enabled) {
  const btn = document.querySelector('#bookNowBtn, [data-button-submit]');
  if (!btn) return;
  if (enabled) {
    btn.classList.remove('hidden', 'opacity-50', 'pointer-events-none');
    btn.removeAttribute('disabled');
    btn.setAttribute('aria-disabled', 'false');
  } else {
    btn.classList.add('hidden');
    btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('aria-disabled', 'true');
  }
}

function setSubmitState(state, label) {
  const btn = document.querySelector("[data-button-submit]");
  if (!btn) return;

  btn.classList.remove("bg-dark-blue", "bg-green-500", "bg-red-500");
  if (state === "loading") {
    btn.classList.add("bg-dark-blue");
    btn.innerHTML =
      "<span class='uppercase font-black text-base md:text-[20px]'>Processing…</span>";
    btn.disabled = true;
  } else if (state === "success") {
    btn.classList.add("bg-green-500");
    btn.innerHTML =
      "<span class='uppercase font-black text-base md:text-[20px]'>" +
      (label || "Booked!") +
      "</span>";
    btn.disabled = true;
  } else if (state === "error") {
    btn.classList.add("bg-red-500");
    btn.innerHTML =
      "<span class='uppercase font-black text-base md:text-[20px]'>" +
      (label || "Error") +
      "</span>";
    btn.disabled = false;
  }
}


window.addEventListener("load", (event) => {
  checkMembershipStatus();
  getBookingInfo();
  setBookNowVisibility(false);
});

calendar.init();
disableCalendarWithMessage("Please select a service first");
if (cachedClubroomAPIBookingData) populateServicesContainer();
